import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "../../../redux/reduxToolkitServices/_commonServices/commonServices";
import {
  Container,
  Heading,
  MainSection,
  WorkSection,
  CheckBoxWrapper,
  LeftSection,
} from "pages/Messages/VDU/VDUStyled";
import { CircleBtn, AccordionStyled } from "assets/css/globle";
import PresetMessagesTable from "pages/Messages/VDU/Table";
// global store imports from globalStore
import { useHookstate } from "@hookstate/core";
import {
  MESSAGE_VDU_GLOBAL_STATE,
  SIDENAV_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
  MESSAGE_FLEET_GLOBAL_STATES,
} from "../../../globalStore/globalStore";
import { ForwardMessageCheckbox } from "commonComponents/FormElement/Checkbox/ForwardMessageCheckbox";
import { AllowFreeTextMessageCheckbox } from "commonComponents/FormElement/Checkbox/AllowFreeTextMessageCheckbox";
import { useTranslation } from "react-i18next";
import { isUserBasic, isUserReadOnly, isUserAdmin, isUserMaster } from "constant";
import { Tooltip } from "@mui/material";

const Vdu = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { globalMessageVDU, globalIndexVDU, setSave } = useHookstate(MESSAGE_VDU_GLOBAL_STATE);
  const { forwardMessageGlobalState } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);

  const [vduPresetMessage, setVduPresetMessage] = useState("");
  const [isAlertMessage, setIsAlertMessage] = useState("");
  const [isAlertTitle, setIsAlertTitle] = useState("");
  const [isAlertMessageBackup, setIsAlertMessageBackup] = useState("");
  const [isAlertTitleBackup, setIsAlertTitleBackup] = useState("");
  const [activeButton, setActiveButton] = useState(false);
  const [shouldSaveButtonBeDisabled, setShouldSaveButtonBeDisabled] = useState(true);

  //const []
  const dispatch = useDispatch();
  const { vduMessagesSettingData, getUserRole } = useSelector((state) => state.commonReducers) || [];
  const { sideDrawerActiveTabState } = useHookstate(SIDENAV_GLOBAL_STATE);

  useEffect(() => {
    setShouldSaveButtonBeDisabled(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role) || vduPresetMessage === "");

    if (globalMessageVDU.get()) {
      setVduPresetMessage(globalMessageVDU.get());
    } 
  }, [globalMessageVDU.get()]);

  useEffect(() => {
    setVduPresetMessage("");
    globalMessageVDU.set("");
  }, [sideDrawerActiveTabState.get()]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.vduGetMessagesSettingServices(siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    setIsAlertTitle(
      vduMessagesSettingData?.MessageInfo?.Weather?.Title
        ? vduMessagesSettingData?.MessageInfo?.Weather?.Title
        : ""
    );
    setIsAlertMessage(
      vduMessagesSettingData?.MessageInfo?.Weather?.Message
        ? vduMessagesSettingData?.MessageInfo?.Weather?.Message
        : ""
    );
    setIsAlertTitleBackup(
      vduMessagesSettingData?.MessageInfo?.Weather?.Title
        ? vduMessagesSettingData?.MessageInfo?.Weather?.Title
        : ""
    );
    setIsAlertMessageBackup(
      vduMessagesSettingData?.MessageInfo?.Weather?.Message
        ? vduMessagesSettingData?.MessageInfo?.Weather?.Message
        : ""
    );
  }, [vduMessagesSettingData?.MessageInfo?.Weather?.Title]);

  const handelClearButton = () => {
    setVduPresetMessage("");
  };

  useEffect(() => {
    localStorage.setItem("vduPresetMessage", vduPresetMessage);
  }, [vduPresetMessage]);

  const handelSaveWeather = () => {
    setActiveButton(false);
    let _VDUdata = JSON.parse(JSON.stringify(vduMessagesSettingData));

    let _VDUmessage = { ..._VDUdata?.MessageInfo?.Weather };
    _VDUmessage.Title = isAlertTitle;
    _VDUmessage.Message = isAlertMessage;
    _VDUdata.MessageInfo.Weather = _VDUmessage;
    dispatch(
      COMMON_SERVICES.vduPutMessagesSettingServices(_VDUdata, siteId.get())
    ).then(() => {
      dispatch(COMMON_SERVICES.vduGetMessagesSettingServices(siteId.get()));
    });
  };

  // handel save alert button click
  const handelSaveButton = () => {
    let _VDUdata = JSON.parse(JSON.stringify(vduMessagesSettingData));
    let _VDUmessage = _VDUdata?.MessageInfo?.Messages
      ? [..._VDUdata?.MessageInfo?.Messages?.Message]
      : [];
    if (globalIndexVDU.get() >= 0) {
      _VDUmessage[globalIndexVDU.get()].$text = vduPresetMessage;
    } else {
      let data = {
        $Dest: "0",
        $Src: "0",
        $Relay: forwardMessageGlobalState.get() === true ? "2" : "1",
        $text: vduPresetMessage,
      };

      _VDUmessage.push(data);
    }
    globalIndexVDU.set(-1);
    if (_VDUdata.MessageInfo.Messages)
      _VDUdata.MessageInfo.Messages.Message = _VDUmessage;
    else
      _VDUdata.MessageInfo.Messages = {
        Message: _VDUmessage,
      };

    dispatch(
      COMMON_SERVICES.vduPutMessagesSettingServices(_VDUdata, siteId.get())
    ).then(() => {
      dispatch(COMMON_SERVICES.vduGetMessagesSettingServices(siteId.get()));
      setVduPresetMessage("");
    });
    setSave.set(false);
  };

  const handelClearAlertButton = () => {
    setActiveButton(false);
    setIsAlertMessage(isAlertMessageBackup);
    setIsAlertTitle(isAlertTitleBackup);
     setShouldSaveButtonBeDisabled(true);
  };

  const handleVduPresetMessage = (e) => {
     setShouldSaveButtonBeDisabled(false);
     setSave.set(true);
     setVduPresetMessage(e.target.value);
  }

  return (
    <Container>
      <AccordionStyled>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Heading>
              <h3>{t("Weather_alert")}</h3>
            </Heading>
          </AccordionSummary>
          <AccordionDetails>
            <WorkSection>
              <div className="input-wrapper">
                <p>{t("Alert_heading")}</p>
                <input
                  disabled={
                    isUserBasic(getUserRole && getUserRole?.Role) ||
                    isUserReadOnly(getUserRole && getUserRole?.Role)
                  }
                  value={isAlertTitle}
                  onChange={(e) => {
                    setActiveButton(true);
                    setIsAlertTitle(e.target.value);
                  }}
                />
              </div>
              <div className="input-wrapper">
                <p>{t("Alert_message")}</p>
                <textarea
                  disabled={
                    isUserBasic(getUserRole && getUserRole?.Role) ||
                    isUserReadOnly(getUserRole && getUserRole?.Role)
                  }
                  value={isAlertMessage}
                  onChange={(e) => {
                    setActiveButton(true);
                    setIsAlertMessage(e.target.value);
                  }}
                  rows="4"
                />
              </div>
              <div className="action-btn">
                <Tooltip title={t("Save")} placement="top">
                  <span>
                    <CircleBtn
                      disabled={
                        isUserBasic(getUserRole && getUserRole?.Role) ||
                        isUserReadOnly(getUserRole && getUserRole?.Role) ||
                        isAlertMessage === "" ||
                        !activeButton
                      }
                      onClick={() => handelSaveWeather()}
                      className={
                        isUserBasic(getUserRole && getUserRole?.Role) ||
                          isUserReadOnly(getUserRole && getUserRole?.Role) ||
                          isAlertMessage === "" ||
                          !activeButton
                          ? "disabled pointer-event-none"
                          : "active"
                      }
                    >
                      {t("Save")}
                    </CircleBtn>
                  </span>
                </Tooltip>
                <Tooltip title={t("Reset")} placement="top">
                  <CircleBtn
                    disabled={
                      isUserBasic(getUserRole && getUserRole?.Role) ||
                      isUserReadOnly(getUserRole && getUserRole?.Role)
                    }
                    onClick={() => handelClearAlertButton()}
                  >
                    {t("Reset")}
                  </CircleBtn>
                </Tooltip>
              </div>
            </WorkSection>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Heading>
              <h3>{t("Messaging")}</h3>
            </Heading>
          </AccordionSummary>
          <AccordionDetails>
            <WorkSection>
              <div className="checkbox-wrapper">
                <CheckBoxWrapper className="no-bdr pb-0">
                  <AllowFreeTextMessageCheckbox
                    identification="FT"
                    disableState={
                      !isUserAdmin(getUserRole && getUserRole?.Role) &&
                      !isUserMaster(getUserRole && getUserRole?.Role)
                    }
                  />
                </CheckBoxWrapper>
              </div>
            </WorkSection>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Heading>
              <h3>{t("Preset_messages")}</h3>
            </Heading>
          </AccordionSummary>
          <AccordionDetails>
            <MainSection>
              <LeftSection>
                <Tooltip
                  title={t("Forward_messages_to_marshals_per_site")}
                  placement="top"
                >
                  <CheckBoxWrapper>
                    <ForwardMessageCheckbox
                      identification="FM"
                      disableState={
                        isUserBasic(getUserRole && getUserRole?.Role) ||
                        isUserReadOnly(getUserRole && getUserRole?.Role)
                      }
                    />
                  </CheckBoxWrapper>
                </Tooltip>
                <div className="input-wrapper">
                  <p>{t("New_message")}</p>
                  <textarea
                    maxLength={182}
                    disabled={
                      isUserBasic(getUserRole && getUserRole?.Role) ||
                      isUserReadOnly(getUserRole && getUserRole?.Role)
                    }
                    rows="6"
                    placeholder={t("Type_your_message")}
                    value={vduPresetMessage}
                    onChange={(e) => handleVduPresetMessage(e)}
                  />
                </div>
                <div className="action-btn">
                  <Tooltip title={t("Save")} placement="top">
                    <span>
                      <CircleBtn
                        disabled={shouldSaveButtonBeDisabled}
                        style={{
                          opacity: setSave.get() === true ? 1 : 0.5,
                          pointerEvents:
                            setSave.get() === true ? "auto" : "none",
                        }}
                        className={shouldSaveButtonBeDisabled ? "pointer-event-none" : "active"}
                        onClick={() => handelSaveButton()}
                      >
                        {t("Save")}
                      </CircleBtn>
                    </span>
                  </Tooltip>
                  <Tooltip title="Clear" placement="top">
                    <CircleBtn
                      disabled={
                        isUserBasic(getUserRole && getUserRole?.Role) ||
                        isUserReadOnly(getUserRole && getUserRole?.Role)
                      }
                      onClick={() => {
                        setSave.set(false);
                        handelClearButton();
                      }}
                    >
                      {t("Clear")}
                    </CircleBtn>
                  </Tooltip>
                </div>
              </LeftSection>
              <PresetMessagesTable />
            </MainSection>
          </AccordionDetails>
        </Accordion>
      </AccordionStyled>
    </Container>
  );
};

export default Vdu;
